import {createSlice} from '@reduxjs/toolkit'
import {
    getBranchActivityAction,
    fetchAllotment,
    fetchMyCarriers,
    getMyShipmentsAction,
    getspecialDealsAction
} from './ff-opsdash.action'

interface IBranchActivityProps {
    totalBookingCount: number
    maxTotalBooking: number
    branchActivityData: Array<Record<string, any>>
    isLoading: boolean
    error: Record<string, any> | null
}
interface MyAllotmentProps {
    response: Array<Record<string, any>>
    isLoading: boolean
    error: Record<string, any> | null
}
interface myCarrierDataProps {
    response: Array<Record<string, any>>
    isLoading: boolean
    error: Record<string, any> | null
}
interface ITopCarriersProps {
    startDate: string
    endDate: string
    topCarriersData: Array<Record<string, any>>
}
interface IMyShipmentsProps {
    response: Array<Record<string, any>>
    isLoading: boolean
    error: Record<string, any> | null
}
interface IspecialDealsProps {
    response: Array<Record<string, any>>
    isLoading: boolean
    error: Record<string, any> | null
}
interface IaccountNumberProps {
    response: Array<Record<string, any>>
    isLoading: boolean
    error: Record<string, any> | null
}

interface IInitialStateProps {
    isLoading: boolean
    error: Record<string, unknown> | null
    branchActivity: IBranchActivityProps | Record<string, any>
    topCarriers: ITopCarriersProps | Record<string, any>
    topOdPairs: Array<Record<string, any>>
    MyAllotments: MyAllotmentProps | Record<string, any>
    myCarriers: myCarrierDataProps | Record<string, any>
    myShipments: IMyShipmentsProps | Record<string, any>
    specialDeals: IspecialDealsProps | Record<string, any>
    accountNumbers: IaccountNumberProps | Record<string, any>
}

const initialState: IInitialStateProps = {
    isLoading: false,
    error: null,
    branchActivity: {isLoading: true},
    MyAllotments: {},
    topCarriers: {},
    topOdPairs: [],
    myCarriers: {},
    myShipments: {},
    specialDeals: {},
    accountNumbers: {}
}

const ffOpsDashboardSlice = createSlice({
    name: 'Operational Dashboard',
    initialState,
    reducers: {
        resetState: () => initialState,
        resetShipmentState: (state) => {
            state.myShipments = {}
        }
    },
    extraReducers: (builder) =>
        builder
            .addCase(getBranchActivityAction.pending, (state) => {
                state.branchActivity.isLoading = true
                state.branchActivity.error = null
            })
            .addCase(getBranchActivityAction.fulfilled, (state, action: any) => {
                state.branchActivity.isLoading = false
                state.branchActivity.error = null

                const {totalBookingCount, maxTotalBooking, branchActivityData} = action.payload.branchActivityResponse
                state.branchActivity = {...state.branchActivity, totalBookingCount, maxTotalBooking, branchActivityData}

                const {startDate, endDate, topCarriersData} = action.payload.topCarriersResponse
                state.topCarriers = {...state.topCarriers, startDate, endDate, topCarriersData}

                state.topOdPairs = action.payload.topOdPairsResponse

                state.accountNumbers = action.payload.accountNumberMapResponse
            })
            .addCase(getBranchActivityAction.rejected, (state, action: any) => {
                state.branchActivity.isLoading = false
                state.branchActivity.error = action.payload.error
            })
            .addCase(fetchAllotment.pending, (state: any, action) => {
                state.MyAllotments.isLoading = true
                state.MyAllotments.response = null
                state.MyAllotments.error = null
            })
            .addCase(fetchAllotment.fulfilled, (state: any, action) => {
                state.MyAllotments.isLoading = false
                state.MyAllotments.response = action.payload
                state.MyAllotments.error = null
            })
            .addCase(fetchAllotment.rejected, (state: any, action: any) => {
                state.MyAllotments.isLoading = false
                state.MyAllotments.response = null
                state.MyAllotments.error = action.payload.error
            })
            .addCase(fetchMyCarriers.pending, (state) => {
                state.myCarriers.isLoading = true
                state.myCarriers.error = null
                state.myCarriers.response = null
            })
            .addCase(fetchMyCarriers.fulfilled, (state, action: any) => {
                state.myCarriers.isLoading = false
                state.myCarriers.error = null
                state.myCarriers.response = action.payload
            })
            .addCase(fetchMyCarriers.rejected, (state, action: any) => {
                state.myCarriers.isLoading = false
                state.myCarriers.error = action.payload.error
                state.myCarriers.response = null
            })
            .addCase(getMyShipmentsAction.pending, (state, action: any) => {
                state.myShipments.isLoading = true
                state.myShipments.error = null
                state.myShipments.response = null
            })
            .addCase(getMyShipmentsAction.fulfilled, (state, action: any) => {
                state.myShipments.isLoading = false
                state.myShipments.error = null
                state.myShipments.response = action.payload
            })
            .addCase(getMyShipmentsAction.rejected, (state, action: any) => {
                state.myShipments.isLoading = false
                state.myShipments.response = null
                state.myShipments.error = action.payload.error
            })
            .addCase(getspecialDealsAction.pending, (state, action: any) => {
                state.specialDeals.isLoading = true
                state.specialDeals.error = null
                state.specialDeals.response = null
            })
            .addCase(getspecialDealsAction.fulfilled, (state, action: any) => {
                state.specialDeals.isLoading = false
                state.specialDeals.error = null
                state.specialDeals.response = action.payload
            })
            .addCase(getspecialDealsAction.rejected, (state, action: any) => {
                state.specialDeals.isLoading = false
                state.specialDeals.response = null
                state.specialDeals.error = action.payload.error
            })
})

export const {resetState, resetShipmentState} = ffOpsDashboardSlice.actions
export const {reducer: opsDashboardReducer} = ffOpsDashboardSlice
